"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9216],{

/***/ 9216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ BackgroundGoogleAds; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




function BackgroundGoogleAds() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("tablet"), 1), isMobile = ref[0];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var desktopBackgroundRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var mobileBackgroundRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    // Log de debug para modo de operação
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isLoading && isMobile != null) setIsLoading(false);
    }, [
        isMobile
    ]);
    return isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileTopAds, {
        ref: mobileBackgroundRef
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopBackgroundAds, {
        ref: desktopBackgroundRef
    });
}
var MobileTopAds = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function MobileTopAds(_, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute bottom-0 left-0 top-[60px] flex h-[100px] w-full items-center justify-center has-[iframe[width='2000']]:fixed has-[iframe[width='2000']]:items-start tablet:left-[60px] tablet:top-0 tablet:w-[calc(100%_-_60px)] [&>span]:has-[iframe]:hidden [&_iframe[width='2000']]:absolute [&_iframe]:relative [&_iframe]:w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: ref,
            className: "bg-ad active relative flex items-start justify-center",
            id: "div-gpt-ad-background/topo-mobile",
            "data-ad": "true"
        })
    });
});
var DesktopBackgroundAds = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function DesktopBackgroundAds(_, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute left-0 top-0 flex h-[250px] w-full items-center justify-center has-[iframe[width='2000']]:fixed has-[iframe[width='2000']]:h-screen tablet:left-[60px] tablet:w-[calc(100%_-_60px)] [&_iframe[width='2000']]:absolute [&_iframe[width='2000']]:h-full [&_iframe[width='2000']]:w-full [&_iframe]:relative [&_iframe]:left-0 [&_iframe]:top-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: ref,
            className: "bg-ad active",
            id: "div-gpt-ad-background/bg-topo-desktop",
            "data-ad": "true"
        })
    });
});


/***/ })

}]);